// This file is created to communicate counter/state to the amplitude. The correct counter and state
// are not known until trackView is called (the function that adds document id to localStorage).
//
// After tracking this promise is resolved, and the right values can be fetched
//
// But we do not have proper code-splitting setup, so this file included in one pack, is not the same
// as in the other pack, as the result I have to setup state on window object, that independent of webpack we use

if (window._viewRestrictState === undefined) {
  window._viewRestrictState = {};
}
// Temporary resolve function, that calls itself.
if (window._viewRestrictState.resolve === undefined) {
  window._viewRestrictState.resolve = function (value) {
    setTimeout(function () {
      window._viewRestrictState.resolve(value);
    }, 0);
  };
}
if (window._viewRestrictState.promise === undefined) {
  window._viewRestrictState.promise = new Promise(
    (resolveF, _reject) => (window._viewRestrictState.resolve = resolveF)
  );
}

export const resolve = window._viewRestrictState.resolve;
const promise = window._viewRestrictState.promise;
export default promise;
